module.exports = __webpack_public_path__ + "media/images/logos/DeMontfort-16363b3f6a70056020f8189943863911.svg";